import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';
import accessibleDropDown from '@/common/mixins/accessibility/accessible-dropdown';

export default {
    name: 'marketTrendsDropdown',
    components: {
        mvtDropdownList
    },
    props: {
        selectedItem: {
            type: Object,
            default: null,
        },
        options: {
            type: Array,
            default: [],
            required: true,
        },
    },
    computed: {
        getSelectedItem() {
            return this.selectedItem;
        },
        getItems() {
            if(this.options && this.options.length > 0) {
                return this.options.map(option => {
                    return {
                        ...option,
                        text: option.name,
                        value: option.id,
                    }
                });
            }
            return [];
        }
    },
    watch: {
        options: function (val) {
            this.options = val;
        },
    },
    methods: {
        change(item) {
            if (this.selectedItem.id != item.id) {
                this.$emit('changed', item);
            }
        },
    },
};
